export const summaryRows: string[] = [
  'Volume 01 — The Molecule of Life: DNA, Genes, Chromosomes & Replication',
  "Volume 02 — Mendel's Laws & Patterns of Inheritance",
  'Volume 03 — Gene Expression: From DNA to Protein & How Genes Are Controlled',
  'Volume 04 — Mutations, Genetic Variation & Human Genetics',
  'Volume 05 — Biotechnology & Genetic Engineering: From PCR to CRISPR',
  'Volume 06 — Population Genetics, Evolution & Bioethics',
  'Bonus 1 — Hands-On DNA & Genetics Classroom Labs',
  'Bonus 2 — Punnett Square & Pedigree Problem Bank with Answer Keys',
  'Bonus 3 — Illustrated Genetics Glossary & Vocabulary Cards',
  'Bonus 4 — Genetics Quick-Reference Charts & Diagram Pack',
  'Bonus 5 — Landmark Discoveries in Genetics: Timeline & Case Studies',
  '7-day money-back guarantee',
  'Instant access',
];
